<template>
  <div class="bg-white rounded-lg shadow-sm mb-6">
    <div class="flex items-center px-6 py-4 rounded-t-lg">
      <h2 class="text-lg font-semibold">Registrar pago</h2>
    </div>
    
    <div class="p-6">
      <PaymentBox
        :payment_methods="payment_methods"
        :balance="balance"
        :change="change"
        :order="null"
        :client="client"
        @success="onPaymentSuccess"
      />
    </div>
  </div>
</template>

<script>
import PaymentBox from '@/Shared/PaymentBox.vue'

export default {
  components: {
    PaymentBox
  },

  props: {
    payment_methods: {
      type: Array,
      required: true
    },
    balance: {
      type: Number,
      required: true
    },
    change: {
      type: Number,
      required: true
    },
    order: {
      type: Object,
      required: true
    },
    client: {
      type: Object,
      required: true
    }
  },

  methods: {
    onPaymentSuccess() {
      this.$emit('success')
    }
  }
}
</script> 